import { useEffect, useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { adminApi, formatApiErrorDetail } from "@/lib/adminApi";
import { Field, inputCls, btnPrimary } from "./ui";

export default function SettingsPanel() {
  const [premiereAt, setPremiereAt] = useState("");
  const [current, setCurrent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi.get("/settings").then((r) => {
      const s = r.settings || {};
      setCurrent(s.premiere_at || null);
      if (s.premiere_at) setPremiereAt(s.premiere_at.slice(0, 16));
    }).catch(() => {});
  }, []);

  const save = async () => {
    if (!premiereAt) return toast.error("Pick a date and time first.");
    setSaving(true);
    try {
      const res = await adminApi.put("/settings", {
        premiere_at: new Date(premiereAt).toISOString(),
      });
      setCurrent(res.settings.premiere_at);
      toast.success("Premiere date updated.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings-panel" className="max-w-2xl">
      <p className="text-sm leading-relaxed text-latte">
        Set when Episode One drops. The homepage counts down live and flips to
        &ldquo;Now Streaming&rdquo; the moment this passes &mdash; as long as a
        published episode exists. Set the date, publish the episode, and the
        site does the rest.
      </p>

      <div className="mt-8 rounded-2xl border border-gold/30 bg-cocoa p-6 md:p-10">
        {current && (
          <p data-testid="admin-premiere-current" className="mb-6 text-sm text-latte">
            Currently set to{" "}
            <span className="font-semibold text-gold">
              {format(new Date(current), "EEEE, MMMM d, yyyy 'at' h:mm a")}
            </span>
          </p>
        )}
        <Field label="Premiere date & time (your local time)">
          <input
            data-testid="admin-premiere-input"
            type="datetime-local"
            className={inputCls}
            value={premiereAt}
            onChange={(e) => setPremiereAt(e.target.value)}
          />
        </Field>
        <button
          data-testid="admin-premiere-save-button"
          onClick={save}
          disabled={saving}
          className={`${btnPrimary} mt-6`}
        >
          {saving ? "Setting the date…" : "Save Premiere Date"}
        </button>
      </div>
    </div>
  );
}
